import { Button } from 'antd';
import type { FC } from 'react';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import type { RootState } from 'app/redux/store';
import type { IHotel } from 'app/typings';
import { dayjs } from 'app/utils/dayjs';

export const WebsiteButtonComponent: FC<Props> = ({ hotel }) => {
  const validURL = (str: string) => {
    const pattern =
      /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;

    return !!pattern.test(str);
  };

  const onWebsiteClick = useCallback(() => {
    if (!hotel) {
      return;
    }

    const startPattern = hotel.bookingUrl.match(/{start:.*?}/)?.[0];

    if (startPattern) {
      const startDateFormat = startPattern?.match(/^\{start:(.+)\}$/)?.[1];
      const startDate = dayjs(Date.now()).format(
        startDateFormat?.toUpperCase()
      );

      const endPattern = hotel.bookingUrl.match(/{end:.*?}/)?.[0];

      if (endPattern) {
        const endDateFormat = endPattern?.match(/^\{end:(.+)\}$/)?.[1];
        const endDate = dayjs(Date.now())
          .add(1, 'days')
          .format(endDateFormat?.toUpperCase());

        window.open(
          hotel.bookingUrl
            .replace(startPattern, startDate)
            .replace(endPattern, endDate)
        );
      } else {
        window.open(hotel.bookingUrl.replace(startPattern, startDate));
      }
    } else {
      window.open(hotel.bookingUrl);
    }
  }, [hotel]);

  if (!hotel) {
    return null;
  }

  return (
    <Button
      disabled={
        !hotel?.bookingUrl ||
        !hotel.bookingUrl.length ||
        !validURL(hotel.bookingUrl)
      }
      onClick={onWebsiteClick}
    >
      Hotel website
    </Button>
  );
};

export const mapStateToProps = (state: RootState) => ({
  hotel: state.hotelAdmin.hotels.find((h) => h.id === state.hotelAdmin.hotelId),
});

type Props = {
  hotel: IHotel | undefined;
};

export const WebsiteButton = connect(mapStateToProps)(WebsiteButtonComponent);
